import styled from 'styled-components/macro';

import HeadingBase from '@components/common/core/DataDisplay/Heading';
import InputGroupBase from '@components/common/core/Inputs/InputGroup';
import TextFieldBase from '@components/common/core/Inputs/TextField';
import LabelBase from '@components/common/core/DataDisplay/Label';
import FormBase from '@components/common/core/Inputs/Form';
import ImageBase from '@components/common/core/DataDisplay/Image';
import TextBase from '@components/common/core/DataDisplay/Text';

export const Form = styled(FormBase)`
  width: auto;

  @media only screen and (max-width: 920px) {
    margin: 0 auto;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
`;

export const Input = styled(TextFieldBase)`
  width: 100%;
`;

export const TextField = styled(TextFieldBase)`
  width: 100%;
`;

export const Label = styled(LabelBase)``;

export const InputGroup = styled(InputGroupBase)`
  max-width: 408px;
  margin-top: 16px;
`;

export const IntegrationTitleText = styled(HeadingBase)``;

export const Body = styled.div``;

export const IntegrationTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 28px;
  gap: 16px;
`;

export const Title = styled(HeadingBase)`
  font-size: 1.75rem;
  line-height: 120%;
  margin-bottom: 36px;
`;

export const Header = styled.div``;

export const TutorialLink = styled.a`
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 150%;
  color: ${({ theme }) => theme.colors.green.default};
  text-decoration: none;
  display: inline-block;
  transition: all 0.3s;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:active {
    text-decoration: underline;
    filter: brightness(0.9);
  }
`;

export const TutorialContent = styled(TextBase)`
  display: inline-block;
  font-size: 0.875rem;
  line-height: 150%;
  margin-bottom: 8px;
`;

export const TutorialTitle = styled(HeadingBase)`
  font-size: 1rem;
  line-height: 120%;
  display: inline-block;
  margin-bottom: 8px;
`;

export const TutorialImage = styled(ImageBase)`
  max-width: 140px;
  margin-bottom: 24px;
  display: block;
`;

export const TutorialWrapper = styled.div`
  max-width: 416px;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.gray[4]};
  border-radius: 7px;
  padding: 28px 32px;
  box-sizing: border-box;
  height: fit-content;
`;

export const FormWrapper = styled.div`
  width: 100%;
`;

export const Wrapper = styled.div`
  padding: 142px 32px;
  max-width: calc(1008px + 64px);
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  gap: 28px;

  @media only screen and (max-width: 1292px) {
    flex-direction: column;
    max-width: calc(620px + 64px);
  }
`;
